import { Address } from './Address';
import { BasketDeliveryAddress } from './BasketDeliveryAddress';

class UserGeoLocation {
    latitude: number;
    longitude: number;
}

export class SearchedAddresses {
    curbside?: Address;
    delivery?: BasketDeliveryAddress;
    lastMethod?: string;
    userGeoLocation?: UserGeoLocation;
}
